import { render, staticRenderFns } from "./ModalBeam.vue?vue&type=template&id=e074cf82&scoped=true&"
import script from "./ModalBeam.vue?vue&type=script&lang=js&"
export * from "./ModalBeam.vue?vue&type=script&lang=js&"
import style0 from "./ModalBeam.vue?vue&type=style&index=0&id=e074cf82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e074cf82",
  null
  
)

/* custom blocks */
import block0 from "./ModalBeam.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports